/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { EnrollmentStatus } from './EnrollmentStatus';
import {
    EnrollmentStatusFromJSON,
    EnrollmentStatusFromJSONTyped,
    EnrollmentStatusToJSON,
    EnrollmentStatusToJSONTyped,
} from './EnrollmentStatus';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ParentEnrollmentReviewItem
 */
export interface ParentEnrollmentReviewItem {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ParentEnrollmentReviewItem
     */
    activityId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ParentEnrollmentReviewItem
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ParentEnrollmentReviewItem
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ParentEnrollmentReviewItem
     */
    studentName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ParentEnrollmentReviewItem
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ParentEnrollmentReviewItem
     */
    className: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ParentEnrollmentReviewItem
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ParentEnrollmentReviewItem
     */
    summaryLine: string;
    /**
     * 
     * @type {Date}
     * @memberof ParentEnrollmentReviewItem
     */
    occurredAt: Date;
    /**
     * 
     * @type {any}
     * @memberof ParentEnrollmentReviewItem
     */
    effectiveDate: any | null;
    /**
     * 
     * @type {EnrollmentStatus}
     * @memberof ParentEnrollmentReviewItem
     */
    enrollmentStatus: EnrollmentStatus;
    /**
     * 
     * @type {Date}
     * @memberof ParentEnrollmentReviewItem
     */
    reviewedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ParentEnrollmentReviewItem
     */
    reviewedByEmail: string | null;
}



/**
 * Check if a given object implements the ParentEnrollmentReviewItem interface.
 */
export function instanceOfParentEnrollmentReviewItem(value: object): value is ParentEnrollmentReviewItem {
    if (!('activityId' in value) || value['activityId'] === undefined) return false;
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('summaryLine' in value) || value['summaryLine'] === undefined) return false;
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    if (!('effectiveDate' in value) || value['effectiveDate'] === undefined) return false;
    if (!('enrollmentStatus' in value) || value['enrollmentStatus'] === undefined) return false;
    if (!('reviewedAt' in value) || value['reviewedAt'] === undefined) return false;
    if (!('reviewedByEmail' in value) || value['reviewedByEmail'] === undefined) return false;
    return true;
}

export function ParentEnrollmentReviewItemFromJSON(json: any): ParentEnrollmentReviewItem {
    return ParentEnrollmentReviewItemFromJSONTyped(json, false);
}

export function ParentEnrollmentReviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentEnrollmentReviewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'activityId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['activityId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'summaryLine': json['summaryLine'],
        'occurredAt': (new Date(json['occurredAt'])),
        'effectiveDate': json['effectiveDate'],
        'enrollmentStatus': EnrollmentStatusFromJSON(json['enrollmentStatus']),
        'reviewedAt': (json['reviewedAt'] == null ? null : new Date(json['reviewedAt'])),
        'reviewedByEmail': json['reviewedByEmail'],
    };
}

export function ParentEnrollmentReviewItemToJSON(json: any): ParentEnrollmentReviewItem {
    return ParentEnrollmentReviewItemToJSONTyped(json, false);
}

export function ParentEnrollmentReviewItemToJSONTyped(value?: ParentEnrollmentReviewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activityId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['activityId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'summaryLine': value['summaryLine'],
        'occurredAt': value['occurredAt'].toISOString(),
        'effectiveDate': value['effectiveDate'],
        'enrollmentStatus': EnrollmentStatusToJSON(value['enrollmentStatus']),
        'reviewedAt': value['reviewedAt'] == null ? value['reviewedAt'] : value['reviewedAt'].toISOString(),
        'reviewedByEmail': value['reviewedByEmail'],
    };
}

